export default "__VITE_ASSET__C9Ip3DyY__"